import { connect } from 'react-redux';

import { closeModal } from '../actions/feedbackPopup';
import FeedbackModal from '../components/FeedbackModal';

export default connect(
  (state) => ({
    isFeedbackSent: state.feedbackPopup.isFeedbackSent,
  }), (dispatch) => ({
    closeModal: () => { dispatch(closeModal()); },
  })
)(FeedbackModal);
